import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=85b9aeb8"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=85b9aeb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports